module.exports = __webpack_public_path__ + "static/media/blog7_sm.054ffa20.webp";